/**
 *
 * @param interval интервал дат в формате yyyy-MM-dd
 * @param callback
 */
export var dateForEach = function dateForEach(interval, callback) {
  var start = new Date(interval.start);
  var end = new Date(interval.end);
  while (start <= end) {
    callback(new Date(start.getTime()));
    var newDate = start.setDate(start.getDate() + 1);
    start = new Date(newDate);
  }
};